import React from 'react';
import Heading from '../components/common/Heading';

const ErrorPage = () => {
  return (<Heading pageTitle={'Please check the site address, wrong URL entered'} />);
};

export default ErrorPage;